export default __webpack_public_path__ + "static/media/github.fe65fc6d.svg";